var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLink01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_434",
    d: "M3.3,32.7c3.7,3.7,9.7,3.7,13.4,0l5.3-5.3l-2.7-2.7L14,30c-2.2,2.2-5.8,2.2-8,0s-2.2-5.8,0-8l5.3-5.3 L8.6,14l-5.3,5.3C-0.4,23-0.4,29,3.3,32.7z M32.7,16.7C36.4,13,36.4,7,32.7,3.3s-9.6-3.7-13.4-0.1c0,0,0,0-0.1,0.1L14,8.7l2.7,2.7 L22,6c2.2-2.2,5.8-2.2,8,0c2.2,2.2,2.2,5.8,0,8l-5.3,5.3l2.7,2.7L32.7,16.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_435",
    d: "M11.3,27.4l-2.7-2.7l16-16l2.7,2.7L11.3,27.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLink01);
export default __webpack_public_path__ + "static/media/ico-link-01.b0b1f635a662f2911ee806578e23b9fc.svg";
export { ForwardRef as ReactComponent };